import { apiURL } from "../utils/Constants";

// Endpoint pubblici (vedi allowedUrls in express_side/index.js): nessun header di auth.

export const getPublicWebinars = async () => {
    const res: Response = await fetch(`${apiURL}webinar/list`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
        return { data: undefined };
    }
    return await res.json();
};

export const savePrivacyConsent = async (payload: any) => {
    const res: Response = await fetch(`${apiURL}user/privacy`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
    });
    return await res.json();
};

export const getClientIP = async (): Promise<string | null> => {
    const res: Response = await fetch(`${apiURL}user/get-ip`, { method: "GET" });
    if (!res.ok) {
        return null;
    }
    const data = await res.json();
    return data.ip;
};
